import React from 'react'
import data from '../data/Works';
import {Card, Button} from 'react-bootstrap';
import { useHistory } from "react-router-dom";

 function WebPages() {

  let history = useHistory();
  
    return (
        <div class="row treciasblokas sonai ">
        <div className="col-12 pav1 text-center text-dark"> <p>ATLIKTI DARBAI</p></div>
        <div className="col-12"> <hr className="text-white-50"/></div>
        <div className="col-12 d-flex flex-wrap flex-row justify-content-center text-center">
        {data.map((work, index)=>(
          <Card style={{ width: '17rem' }} key = {index} className="text-center m-1">
          <Card.Img variant="top"  src={work.imageUrl}  />
          <Card.Body className="d-flex flex-column ">
            <Card.Title>{work.name}</Card.Title>
            <Card.Text >
            {work.description}
            </Card.Text>
            
            {work.butUrl &&
            <Button variant="warning" onClick={()=> window.open(work.butUrl, "_blank")} className = "btn mt-auto ">Žiūrėti</Button> }
          
          </Card.Body>
        </Card>
      ))}
     
    </div>
    <div class="col-md-12 text-center pt-5 ">
       <Button onClick={() => history.goBack()} className="button"  variant="amber"  active type="submit">GRĮŽTI</Button>
    </div>
  </div>
    )
}
export default WebPages